// extracted by mini-css-extract-plugin
module.exports =  {"button":"sO_6JlJ7VjKDWU4c1968","select":"wVHv3nIaf1cSHyZW_rhz"};